import React from 'react';
import PropTypes from 'prop-types';
import classes from '../index.scss';
import ValidationIcon from './ValidationIcon';
import classNames from 'classnames';

const Item = (props) => {
  const lineClasses = classNames({
    [classes["line-rule"]]: true,
    [classes["valid"]]: props.valid === true,
    [classes["invalid"]]: props.valid === false && props.useBullet === false,
  });

  return(
    <li className={ lineClasses }>
      <ValidationIcon {...props} />
      <p className={ classes["text-right"] }>{ props.text }</p>
    </li>
  )
};

Item.propTypes = {
  text: PropTypes.string.isRequired,
  useBullet: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
};

export default Item;
